export const PARTICIPATION_UPDATED_MESSAGE_TYPE = "PARTICIPATION_UPDATED";

export const PARTICIPATION_ACTION_PATH = "/v1/notifications/participation-action";

/** Known production frontends and the API they call. */
export const PARTICIPATION_API_ORIGIN_BY_APP_HOST: Record<string, string> = {
  "app.ilovemacumba.com.br": "https://api.ilovemacumba.com.br",
  "staging.app.ilovemacumba.com.br": "https://staging-api.ilovemacumba.com.br",
};

export function participationActionUrlForAppOrigin(
  appOrigin: string,
): string | null {
  try {
    const apiOrigin = PARTICIPATION_API_ORIGIN_BY_APP_HOST[new URL(appOrigin).hostname];
    if (!apiOrigin) return null;
    return `${apiOrigin}${PARTICIPATION_ACTION_PATH}`;
  } catch {
    return null;
  }
}

export const PARTICIPATION_RESULT_COPY = {
  CONFIRMED: {
    title: "Presença confirmada",
    body: "Sua presença foi registrada.",
  },
  DECLINED: {
    title: "Você não vai",
    body: "Sua resposta foi registrada.",
  },
} as const;

export const PARTICIPATION_FAILURE_COPY = {
  title: "Não foi possível responder",
  body: "Abra o app para confirmar sua presença.",
} as const;

export type ParticipationPushDecision = "CONFIRMED" | "DECLINED";

export function decisionFromNotificationAction(
  action: string,
): ParticipationPushDecision | null {
  if (action === "confirm") return "CONFIRMED";
  if (action === "decline") return "DECLINED";
  return null;
}
